export { default as usersReducers } from 'users/reducers/users_reducers';



// WEBPACK FOOTER //
// src/modules/secured/modules/users/reducers/index.js